import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const Info = (props) => (
  <Icon viewBox="0 0 445 445" {...props}>
    <g>
      <path d="M204 269h38v38h-38zM203 136h38v114h-38z" />
      <path d="M222 22.5c-109.7 0-199 89.3-199 199s89.3 199 199 199 199-89.3 199-199-89.3-199-199-199zm0 379c-99.3 0-180-80.8-180-180s80.8-180 180-180 180 80.8 180 180-80.7 180-180 180z"
      />
    </g>
  </Icon>
);
/*eslint-enable */

export default Info;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/Info.js